import { CSSProperties } from "react";
import ChatWindow from "src/shared/components/ChatWindow";

interface ChatWindowPopupProps {
  roomId: string;
  isMinimized: boolean;
  onClose: () => void;
  onMinimize: () => void;
  onBack?: () => void;
  style?: CSSProperties;
}

const ChatWindowPopup: React.FC<ChatWindowPopupProps> = ({
  roomId,
  isMinimized,
  onClose,
  onMinimize,
  onBack,
  style,
}) => {
  return (
    <ChatWindow
      roomId={roomId}
      isMinimized={isMinimized}
      onClose={onClose}
      onMinimize={onMinimize}
      onBack={onBack}
      style={style}
      variant="popup"
    />
  );
};

export default ChatWindowPopup;
